module.exports = __webpack_public_path__ + "8e4b032b6a7d017d0ff4e7b89da7ce49.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/squinty-30.png
// module id = 1680
// module chunks = 0